import { Range } from 'rc-slider'
import 'rc-slider/assets/index.css'

export default function InputRange(props){
    const {
        value,
        minValue,
        maxValue, 
        onChange, 
        onClick
    } = props

    
    const valor = value

    const handleChange = (evt) => {
        const respose = {
            from: evt[0], to: evt[1] 
        }
        if (onChange) onChange(respose)
    }

    return (
        <Range
            defaultValue={[minValue, maxValue]}
            value={valor}
            min={minValue}
            max={maxValue}
            count={1}
            {...props}
            className="Range"
            onChange={handleChange}
            onClick={onClick}
            railStyle={{ backgroundColor: '#2590b438', height: 3 }}
            trackStyle={{ backgroundColor: '#2591b4', height: 3 }}
            handleStyle={{ borderColor: '#2591b4', backgroundColor: '#2591b4', height: 14, width: 14 }}
        />
    )
}